import { CheckResult } from "../../../../reducers/uploadedBoard";
import React, { useState } from "react";
import Modal from "../../../common/Modal";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import CheckDetails from "./CheckDetails";
import ResultLine from "./ResultLine";

export default function RuleCheck({ result }: { result: CheckResult }) {
  const [checkResultDetails, setCheckResultDetails] = useState(false);

  const closeDetailsModal = () => {
    setCheckResultDetails(false);
  };
  const inspectResult = () => {
    setCheckResultDetails(true);
  };

  return (
    <>
      <ResultLine result={result} inspectResult={inspectResult} />
      <Modal isOpen={checkResultDetails} onRequestClose={closeDetailsModal}>
        <ModalContentWithCloseButton
          title={"Check result details"}
          fullScreen
          closeModal={closeDetailsModal}
        >
          <CheckDetails result={result} />
        </ModalContentWithCloseButton>
      </Modal>
    </>
  );
}
